class LayerTurbine {
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentTurbine = false;
		this.currentTurbineIdx = false;
		
	}
//	
//	
//	
//	placeTurbines(){
//		var self = this;
//		var points = this.scenario.wtgs.slice(0);	
//		
//		LayerTurbine.data = {
//			"type":"FeatureCollection",
//			"features":[]
//		};
//			
//		LayerTurbine.data.features = points.map((f, idx)=>{
//			f.type = 'Feature';
//			
//			f.properties = {...f.properties};
//			if(f.properties && f.properties.tempid)
//				f.id = f.properties.tempid;
//			else
//				f.id = f.turbineid;
//			
//			f.properties.idx = idx;
//			f.properties.name=f.name ? f.name : 'Turbine '+f.turbineid;
//			return f;
//		});
//		
//		if(this.map.getLayer(LayerTurbine.layerId)){
//			this.map.removeLayer(LayerTurbine.layerId);
//			this.map.removeSource(LayerTurbine.sourceId);
//		}
//		if (this.map.hasImage('wtgmarker')) this.map.removeImage('wtgmarker');
//		
//		this.map.loadImage(
//            '/images/icons/wtg_marker.png',
//            (err, image) => {
//                // Throw an error if something goes wrong.
//               // if (err) throw err;
//
//                // Add the image to the map style.
//				if(!this.map.hasImage('wtgmarker'))
//					this.map.addImage('wtgmarker', image);
//				
//				if(!this.map.getSource(LayerTurbine.sourceId))
//					this.map.addSource(LayerTurbine.sourceId, {
//						'type': 'geojson',
//						'data': LayerTurbine.data
//					});
//
//				// Add a new layer to visualize the polygon.
//				if(!this.map.getLayer(LayerTurbine.layerId)){
//					this.map.addLayer({
//						'id': LayerTurbine.layerId,
//						'type': 'symbol',
//						'source': LayerTurbine.sourceId,
//						"paint": {
//							'text-color': "#000000", //Color of your choice
//							'text-opacity': 1,
//							'text-halo-width': 1,
//							'text-halo-color': "#ffffff",
//						}, // reference the data source
//						'layout': {
//							'visibility' : this.map.layerStatus['pl_layer'] ? 'visible' : 'none',
//							'icon-image':'wtgmarker',
//							'icon-anchor' : 'bottom',
//							'icon-allow-overlap' : true,
//							'text-field': ['get', 'name'], //This will get "t" property from your geojson
//							'text-rotation-alignment': "auto",
//							'text-allow-overlap': true,
//							'text-anchor': "top",
//							'text-size': 14,
//						},
//					});
//					
//				}
//            }
//        );
//	}
	
	json(){
		var points = this.scenario.wtgs.slice(0);	
		LayerTurbine.data = {
			"type":"FeatureCollection",
			"features":[]
		};
			
		LayerTurbine.data.features = points.map((f, idx)=>{
			f.type = 'Feature';
			
			f.properties = {...f.properties};
			if(isNaN(f.turbineid))
				f.properties.tempid = f.turbineid;
			else
				f.id = f.turbineid;
			
			f.properties.idx = idx;
			f.properties.turbineid = f.id;
			f.properties.name=f.name ? f.name : 'Turbine '+f.turbineid;
			return f;
		});
		
		const l = {
			'images': [
				{
					'src': '/images/icons/wtg_marker.png',
					'name': 'wtgmarker'
				},
				{
					'src': '/images/icons/wtg_marker_hover.png',
					'name': 'wtgmarker_hover'
				},
				{
					'src': '/images/icons/wtg_marker_on.png',
					'name': 'wtgmarker_on'
				}
			],
			'source': {
				'id': LayerTurbine.sourceId,
				'type': 'geojson',
				'data': LayerTurbine.data
			},
			'layer': [
				{
					'id': LayerTurbine.layerId,
					'type': 'symbol',
					'source': LayerTurbine.sourceId,
					"paint": {
						'text-color': "#000000", //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
					}, // reference the data source
					'layout': {
						'icon-image':['case',
							['boolean', ['get', 'invisible'], false],'',
							['boolean', ['get', 'selected'], false],'wtgmarker_on',
							['boolean', ['get', 'hover'], false],'wtgmarker_hover',
							'wtgmarker'
						],
						'icon-anchor' : 'bottom',
						'icon-allow-overlap' : true,
						'text-field': ['case',
							['boolean', ['get', 'invisible'], false],'',
							['get', 'name']
						]	
						, //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
				}
			]
		};
		return l;
	}
	
		
}

LayerTurbine.layerId = 'turbines_layer';
LayerTurbine.sourceId = 'turbines_source';


export default LayerTurbine;